import createClient from 'openapi-fetch';
/**
 * Typed client for the Lions API, usable from the admin web and React Native. Paths, parameters
 * and bodies are checked against the generated OpenAPI types:
 * `const { data, error } = await client.GET('/v1/app/config')`.
 */
export function createLionsClient(options) {
    const client = createClient({
        baseUrl: options.baseUrl.replace(/\/$/, ''),
        ...(options.headers ? { headers: options.headers } : {}),
        ...(options.credentials ? { credentials: options.credentials } : {}),
        ...(options.fetch ? { fetch: options.fetch } : {}),
    });
    const { getAccessToken } = options;
    if (getAccessToken) {
        client.use({
            async onRequest({ request }) {
                const token = await getAccessToken();
                if (token)
                    request.headers.set('Authorization', `Bearer ${token}`);
                return request;
            },
        });
    }
    return client;
}
export function isProblemDetails(value) {
    if (value === null || typeof value !== 'object')
        return false;
    const candidate = value;
    return (typeof candidate.code === 'string' &&
        typeof candidate.status === 'number' &&
        typeof candidate.traceId === 'string');
}
/** "Reference: <first 8 characters of traceId>" shown with 5xx errors (02 § Clients). */
export const traceReference = (problem) => problem.traceId.slice(0, 8);
//# sourceMappingURL=index.js.map